const variantsContainer = document.querySelector(".swatch-popup-size")
const preOrderTextContentWrapper=  document.querySelectorAll(".pre-order-message__wrapper")

if (variantsContainer) {
    const variantItems = variantsContainer.querySelectorAll(".swatch-element")

    if (variantItems.length){
        variantItems.forEach(item => {
            item.addEventListener("change", ()=>{
                const productTitle = document.querySelector(".product-title")
                const productTitleInner = document.querySelector(".product-title__inner")
                const productTitlePreOrderSuffix = document.querySelector(".product-title__preorder-suffix")
                const input = item.querySelector("input[type='radio']")
                const preOrder = input.getAttribute("data-pre-order")
                const preOrderText = input.getAttribute("data-pre-order-text")

                if (preOrder === 'true'){
                    if (preOrderText){
                        if (productTitleInner){
                            productTitlePreOrderSuffix.innerHTML = "(Pre-order)"
                        }
                        if (preOrderTextContentWrapper){
                            preOrderTextContentWrapper.forEach(container => {
                                container.innerHTML = `
                                    <i><span style="font-weight: 600;">Pre-order:</span>
                                      <span class="pre-order-message">${preOrderText}</span>
                                    </i>
                                `
                            })
                        }
                    }
                }else {
                    if (preOrderTextContentWrapper){
                        preOrderTextContentWrapper.forEach(container => {
                            container.innerHTML = ""
                        })
                    }
                    if (productTitle){
                        productTitlePreOrderSuffix.innerHTML = ""
                    }
                }
            })
        })
    }
}


const form = document.querySelector("form[data-cart-submit]")

function addPreorderTitle(){
    const variantsPreorderJSON = document.querySelector("[data-cart-variants]").innerHTML
    if (variantsPreorderJSON){
        const variantsPreOrder = JSON.parse(variantsPreorderJSON)["preOrder"]
        const cartItems = document.querySelectorAll(".cp-row")
        if (cartItems){
            cartItems.forEach(item => {
                const id=  item.getAttribute("data-item-id")
                if (id){
                    var value = variantsPreOrder.filter(variant => variant[id])[0][id]
                }
                if (value === 'true'){
                    const title = item.querySelector(".info-popup-column h2 a")
                    const titleMainCart = item.querySelector(".content h2 a")

                    if (title){
                        setTimeout(()=>{
                            title.innerHTML += ' (PRE-ORDER)'
                        }, 0)
                    }

                    if (titleMainCart){
                        setTimeout(()=>{
                            titleMainCart.innerHTML += ' (PRE-ORDER)'
                        }, 0)
                    }
                }
            })
        }
    }
}

setTimeout(()=>{
    addPreorderTitle()
}, 500)

if (form){
    form.addEventListener("submit", async function (){
        let formData = new FormData(form)
        await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
        })
            .then(res=>res.json())
            .then(data => {
                fetch("/cart.js")
                    .then(res=>res.json())
                    .then(data=>{
                        if (data.items.length){
                            setTimeout(()=>{
                                addPreorderTitle()
                            }, 500)
                        }
                    })
            })
    })
}